import { render, staticRenderFns } from "./PromoMaterial.vue?vue&type=template&id=5cc4901c&"
import script from "./PromoMaterial.vue?vue&type=script&lang=js&"
export * from "./PromoMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports